<template>
  <button
    class="bg-gray-100 text-gray-800 mb-4 py-1.5 px-4 text-center font-semibold w-full hidden xl:block"
    :disabled="page === 0"
    :class="page === 0 ? ['cursor-default !text-gray-400'] : ''"
    @click="page--"
  >
    <i class="fa-solid fa-chevron-up block !text-sm text-center mx-auto mb-0" />
    <span>Previous Page</span>
  </button>
</template>

<script setup>
const page = defineModel();
</script>

<style scoped>

</style>
